const custInfoSearch = {
    path: 'custInfoSearch',
    name: 'custInfoSearch',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'updateSearch',
        icon: 'HSIconfont hs-icon-inquiry',
        showRealm: ['SYSTEM', 'ADMIN']
    },
    children: [
        {
            path: 'custUpdateRetrieval',
            name: 'custUpdateRetrieval',
            component: () => import('@/views/custUpdateRetrieval'),
            meta: { code: 'updateSearch:retrieval' }

        },
        {
            path: 'custEslAllSearch',
            name: 'custEslAllSearch',
            component: () => import('@/views/custEslAllSearch'),
            meta: { code: 'updateSearch:eslAllStore' }

        },
        {
            path: 'custCdi',
            name: 'custCdi',
            component: () => import('@/views/custCdi'),
            meta: { code: 'updateSearch:cdi' }

        },
        {
            path: 'custAllowEsl',
            name: 'custAllowEsl',
            component: () => import('@/views/custAllowEsl'),
            meta: { code: 'updateSearch:allowEsl' }

        },
        {
            path: 'custInfoSearchGoods',
            name: 'custInfoSearchGoods',
            component: () => import('@/views/custInfoSearchGoods'),
            meta: { code: 'updateSearch:customerGoods' }
        },

    ]
};

export default custInfoSearch;
